<template>
  <footer class="footer text-white pt-5 pb-3">
    <div class="container footerinfo">
      <!-- 顶部：公司信息 + 导航 -->
      <div class="row gy-4">
        <!-- 左侧：公司信息 -->
        <div class="col-lg-4 col-md-6 listitem">
          <h5 class="text-uppercase mb-3 pb-2">
            {{ $t('footer.name') }}
          </h5>
          <p class="mb-1"></p>
          <p class="mb-1">
            {{ $t('footer.email') }}
          </p>
          <p class="mb-1">{{ $t('footer.hotline') }}</p>
          <p class="mb-1">{{ $t('footer.landline') }}</p>
        </div>

        <!-- 中间：关于我们 -->
        <div class="col-lg-2 col-md-3 col-sm-6">
          <h6 class="text-uppercase mb-3 pb-2">{{ $t('footer.about') }}</h6>
          <ul class="list-unstyled">
            <router-link to="/about">
              <li>
                <a href="#" class="text-white text-decoration-none">{{
                  $t('footer.aboutus')
                }}</a>
              </li>
            </router-link>
            <!-- <li>
              <a href="#" class="text-white text-decoration-none">{{
                $t('footer.honors')
              }}</a>
            </li> -->
          </ul>
        </div>

        <!-- 右侧：产品中心 -->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6">
          <h6 class="text-uppercase mb-3 pb-2">
            {{ $t('footer.datacenter') }}
          </h6>
          <ul class="list-unstyled">
            <li>
              <a href="#" class="text-white text-decoration-none">{{
                $t('footer.project')
              }}</a>
            </li>

            <li>
              <a href="#" class="text-white text-decoration-none">{{
                $t('footer.planning')
              }}</a>
            </li>
            <li>
              <a href="#" class="text-white text-decoration-none">
                {{ $t('footer.visit') }}</a
              >
            </li>
          </ul>
        </div> -->

        <!-- 最右侧：联系我们 -->
        <div class="col-lg-3 col-md-12">
          <h6 class="text-uppercase mb-3 pb-1">{{ $t('footer.contact') }}</h6>
          <ul class="list-unstyled">
            <router-link to="/about">
              <li>
                <a href="#" class="text-white text-decoration-none">
                  {{ $t('footer.contactus') }}</a
                >
              </li></router-link
            >
          </ul>
        </div>
      </div>

      <!-- 底部版权 -->
      <div class="row mt-4 pt-3 border-secondary">
        <div class="col text-center text-muted">
          © {{ new Date().getFullYear() }} {{ $t('footer.reserved') }}
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Foot',
};
</script>

<style scoped>
.footer {
  background: #f4f4f4;
  color: #8c8c8c !important;
  a {
    color: #8c8c8c !important;
  }
  /* 背景图 不铺满 写法 */
  background-image: url(~@/assets/images/map.gif);
  background-size: auto; /* 不拉伸，保持原图大小 */
  background-position: center center; /* 放在右下角（可改） */
  background-repeat: no-repeat; /* 不重复 */
}

.footer a:hover {
  color: #8c8c8c !important;
  transition: 0.3s;
}
.pb-2 {
  padding: 0;
}
.mb-3 {
  margin-bottom: 0.2rem !important;
  color: #535353;
}
.listitem {
  text-align: left;
}

@media (max-width: 991px) {
  .listitem {
    text-align: center;
  }
}
</style>
